module.exports = __webpack_public_path__ + "static/media/logo_esg.7a187cc2.png";